<template>
  <slot />
</template>
<script lang="ts" setup></script>
